import { vendorDrawerSchema } from '@main/shared/utils';
import { createRoute, Navigate } from '@tanstack/react-router';

import { VendorLayout } from '../features/layout/vendor';
import { useVendorSearchParams } from '../features/layout/vendor-menu';
import { rootRoute } from './__root';

export const vendorLayout = createRoute({
  getParentRoute: () => rootRoute,
  path: '$vendorToken',
  component: VendorLayout,
  validateSearch: vendorDrawerSchema,
});

export const vendorMain = createRoute({
  getParentRoute: () => vendorLayout,
  path: '/',
  component: () => (
    // oxlint-disable-next-line react/rules-of-hooks
    <Navigate to="/$vendorToken/questionnaires" params={useVendorSearchParams()} />
  ),
});
